import RedactorInput from "./RedactorInput"

export default RedactorInput
